import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm, md },
} = constants.breakpoints;

const white = constants.colors.ui.white[700];
const lightGray = constants.colors.ui.neutral[100];
const blue = constants.colors.brand.blue[25];
const darkBlue = constants.colors.ui.core[700];
const greyDark = constants.colors.ui.neutral[700];
const neutral500 = constants.colors.ui.neutral[500];

export const buttonCss = {
  color: darkBlue,
  padding: "0px",
  textDecoration: "underline",
  fontSize: "16px",
  [mq.downTo(sm)]: {
    fontSize: "18px",
  },
};

export const modalContainerCss = {
  width: "100%",
  height: "99vh",
  backgroundColor: white,
  boxShadow: "0px 16px 40px rgba(0, 0, 0, 0.32)",
  borderRadius: "8px",

  [mq.downTo(xs)]: {
    width: "800px",
    height: "599px",
  },
  [mq.downTo(sm)]: {
    height: "680px",
  },
};

export const modalHeaderCss = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  height: "64px",
  borderBottom: "1px solid" + lightGray,
  padding: "16px",

  [mq.downTo(sm)]: {
    padding: "16px 32px",
  },
};

export const headerTitleCss = {
  fontWeight: "700",
  fontFamily: "Noto Serif",
  fontSize: "20px",
  margin: "0px",
  lineHeight: "31.92px",
  color: greyDark,
};

export const bodyTitleCss = {
  fontWeight: "700",
  fontSize: "24px",
  color: greyDark,
  margin: 0,
};

export const bodyDescriptionCss = (hasChild) => {
  return {
    fontWeight: "400",
    fontSize: "16px",
    margin: hasChild ? "16px 0 24px 0" : "16px 0 0 0",
    color: neutral500,
  };
};

export const linkStyle = {
  color: "#04337A",
  textDecoration: "underline",
  "&:hover": {
    color: "#04337A",
    textDecoration: "underline",
  },
  "&:visited": {
    color: "#04337A",
    textDecoration: "underline",
  },
};

export const buttonWrapper = {
  [mq.upTo(xs)]: {
    width: "100%",
    justifyContent: "center",
  },
};

export const infoBlockWrapper = {
  marginBottom: "40px",
  [mq.downTo(xs)]: {
    marginBottom: "56px",
  },
  ":last-of-type": {
    marginBottom: "0px",
  },
};

export const imageCss = {
  width: "120px",
};

export const imagesWrapper = {
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: blue,
  padding: "16px",
  borderRadius: "16px",
};

export const tokensWrapper = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const closeButtonCss = {
  alignSelf: "start",
  marginTop: "2px",
  [mq.downTo(sm)]: {
    marginTop: "0px",
  },
  color: greyDark,
  "& svg": {
    height: "27px",
  },
};

export const modalBodyCss = {
  height: "76vh",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "baseline",
  margin: "0 10px",
  padding: "16px",
  [mq.downTo(xs)]: {
    height: "435px",
  },
  [mq.downTo(sm)]: {
    height: "520px",
    padding: "32px",
  },
};

export const modalFooterCss = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  height: "81px",
  padding: "16px",
  borderTop: "1px solid" + lightGray,
  justifyContent: "center",
};

export const modalCss = {
  zIndex: 99,
};

export const challengesLearnMoreLinkCss = {
  padding: "0px",
  fontSize: "16px",
  [mq.downTo(sm)]: {
    fontSize: "18px",
  },
  div: {
    cursor: "pointer",
  },
};

export const articleTextWrapper = {};

export const articleTextTitle = {
  fontWeight: "700",
  fontSize: "16px",
  color: greyDark,
  margin: 0,
};

export const articleTextDescription = {
  fontWeight: "400",
  fontSize: "14px",
  color: greyDark,
  margin: 0,
};

export const quizzesImage = {
  width: "100%",
  height: "240px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: "url(/images/icons/LearnMoreQuizzesSmall.svg)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",

  [mq.downTo(sm)]: {
    backgroundImage: "url(/images/icons/LearnMoreQuizzes.svg)",
  },

  [mq.downTo(md)]: {
    backgroundImage: "url(/images/icons/LearnMoreQuizzesLarge.svg)",
  },
};

export const powerWordImage = {
  width: "100%",
  height: "240px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: "url(/images/icons/LearnMorePowerWordSmall.svg)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",

  [mq.downTo(sm)]: {
    backgroundImage: "url(/images/icons/LearnMorePowerWord.svg)",
  },

  [mq.downTo(md)]: {
    backgroundImage: "url(/images/icons/LearnMorePowerWordLarge.svg)",
  },
};

export const guidedHighlightImage = {
  width: "100%",
  height: "240px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: "url(/images/icons/LearnMoreGuidedHighlightingSmall.svg)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",

  [mq.downTo(sm)]: {
    backgroundImage: "url(/images/icons/LearnMoreGuidedHighlighting.svg)",
  },

  [mq.downTo(md)]: {
    backgroundImage: "url(/images/icons/LearnMoreGuidedHighlightingLarge.svg)",
  },
};
